import React from 'react';

import {EventReviewFeedback} from 'src/modules/ai';
import {HeaderFields} from 'src/modules/event-create/constants';
import {REPORTED_INFO} from 'src/modules/event-create/event-create-hovers';
import {HeaderBlock} from 'src/modules/event-create/typedefs';
import {EventType} from 'src/openapi/models/EventType';

import {CheckBox} from '@pb/kit-component-checkbox';
import {Dropdown} from '@pb/kit-component-dropdown-v2';
import {Group} from '@pb/kit-component-group';
import {InfoIconButton} from '@pb/kit-component-icon-button';

type Props = {
    headerValues: HeaderBlock,
    changeRequestId: number | null,
    onChangeCheckboxField: (data: {event: React.SyntheticEvent<HTMLInputElement>, name: string}) => void,
};

export const Reported = (props: Props) => {
    const {headerValues, changeRequestId, onChangeCheckboxField} = props;

    return (
        <>
            {headerValues.type === EventType.USER_EVENT && (
                <Group gap="xs" alignItems="center">
                    <CheckBox
                        name={HeaderFields.reported}
                        label={<strong>Reported</strong>}
                        checked={headerValues.reported}
                        onCheckBoxChange={onChangeCheckboxField}
                    />
                    <Dropdown
                        hoverEnabled={true}
                        clickEnabled={false}
                        maxWidth={500}
                        anchor={({anchorRef, getAnchorProps}) => (
                            <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                        )}>
                        {REPORTED_INFO}
                    </Dropdown>
                    <EventReviewFeedback
                        changeRequestId={changeRequestId}
                        fieldName={HeaderFields.reported}
                    />
                </Group>
            )}
        </>
    );
};
